import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Details.module.sass";
import Icon from "../../../components/Icon";
import Head from "./Head";
import Tabs from "../../../components/Tabs";
import NFT from "./NFT";
import Profile from "./Profile";
import { useParams } from "react-router";
import { UseApi } from "../../../hooks/use-api";
import { GetCard, GetMe } from "../../../Services/lib/user";
import Loader from "../../../components/Loader";
import Empthy from "../../../components/Empty";
import customers from "../../../i11/Customers";
import { useUser } from "../../../context";

const Details = ({ refreshUser, data: id, className, onClose }) => {
	const [tabIndex, setTabIndex] = useState(0);
	const { locale } = useUser();
	const { type } = useParams();
	const [{ isLoading, data }, fetch] = UseApi({
		service: GetMe,
	});

	const [{ data: card }, getCard] = UseApi({
		service: GetCard,
	});

	useEffect(() => {
		if (id) {
			fetch(id._id);
			getCard(id._id);
		}
	}, [id]);
	return (
		<div className={cn(styles.details, className)}>
			<button className={styles.close} onClick={onClose}>
				<Icon name="close" size="20" />
			</button>
			{isLoading ? (
				<div className={styles.loaderWrap}>
					<Loader className={styles.loader} />
				</div>
			) : data ? (
				<>
					<Head
						onClose={onClose}
						refreshUser={refreshUser}
						className={styles.head}
						data={data}
					/>
					{type === "customer" ? (
						<Tabs
							index={tabIndex}
							head={[
								customers[locale].profile,
								customers[locale].minted,
								customers[locale].pending_mint,
								customers[locale].redeemed,
							]}
							setHandler={(i) => {
								setTabIndex(i);
							}}
							body={[
								<Profile card={card} item={data} />,
								<NFT item={data} which="minted" />,
								<NFT item={data} which="pending" />,
								<NFT item={data} which="redeemed" />,
								// <Wallet item={data} />,
								// <Cards />,
								// <Activity />,
							]}
						/>
					) : null}
				</>
			) : (
				<Empthy title="something went wrong" />
			)}
		</div>
	);
};

export default Details;
